import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';

export default function FilterCheckboxDropdown({options, selectedValues, onChange, disabled, itemName, searchPlaceholder}) {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const containerRef = useRef(null);
  const selectableOptions = options.filter(option => option.value !== '');
  const selectedOptions = selectableOptions.filter(option => selectedValues.includes(option.value));
  const filteredOptions = selectableOptions.filter(option => option.label.toLowerCase().includes(keyword.trim().toLowerCase()));
  const isAllSelected = selectableOptions.length > 0 && selectedOptions.length === selectableOptions.length;
  const displayValue = selectedOptions.length === 0
    ? '전체'
    : selectedOptions.length === 1
      ? selectedOptions[0].label
      : `${selectedOptions.length}개 ${itemName} 선택`;

  useEffect(() => {
    const handleOutsideClick = event => {
      if(containerRef.current && !containerRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const toggleOption = option => {
    const nextValues = selectedValues.includes(option.value)
      ? selectedValues.filter(value => value !== option.value)
      : [...selectedValues, option.value];
    onChange(selectableOptions.filter(item => nextValues.includes(item.value)));
  };

  const toggleAll = () => onChange(isAllSelected ? [] : selectableOptions);

  return <Container ref={containerRef}>
    <Trigger type="button" disabled={disabled} $open={open} onClick={() => !disabled && setOpen(current => !current)} aria-haspopup="listbox" aria-expanded={open}>
      <span>{displayValue}</span>
      <DropdownArrow $open={open}>⌄</DropdownArrow>
    </Trigger>
    {open && <Menu>
      <SearchInput value={keyword} onChange={event => setKeyword(event.target.value)} placeholder={searchPlaceholder} autoFocus/>
      <Option as="button" type="button" onClick={toggleAll}>
        <input type="checkbox" checked={isAllSelected} readOnly/>
        <strong>전체 선택</strong>
      </Option>
      <OptionList role="listbox" aria-multiselectable="true">
        {filteredOptions.map(option => <Option as="button" type="button" key={option.value} onClick={() => toggleOption(option)} role="option" aria-selected={selectedValues.includes(option.value)}>
          <input type="checkbox" checked={selectedValues.includes(option.value)} readOnly/>
          <span>{option.label}</span>
        </Option>)}
        {!filteredOptions.length && <EmptyOption>검색 결과가 없습니다.</EmptyOption>}
      </OptionList>
    </Menu>}
  </Container>;
}

const Container = styled.div`position:relative;width:100%;`;
const Trigger = styled.button`
  display:flex;width:100%;height:40px;box-sizing:border-box;align-items:center;justify-content:space-between;
  padding:0 10px 0 11px;border:1px solid ${({$open})=>$open?'#f5811f':'#e5e5e5'};border-radius:6px;
  background:${({disabled})=>disabled?'#f5f5f5':'#fff'};color:${({disabled})=>disabled?'#aaa':'#444'};
  font-family:inherit;font-size:var(--font-size-13);text-align:left;cursor:${({disabled})=>disabled?'not-allowed':'pointer'};
  &:hover{border-color:${({disabled})=>disabled?'#e5e5e5':'#f1d4c2'};}
  &:focus-visible{outline:2px solid rgba(245,129,31,.2);outline-offset:1px;}
  >span:first-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
`;
const DropdownArrow = styled.span`
  flex:0 0 auto;color:#888;font-size:var(--font-size-16);transform:${({$open})=>$open?'rotate(180deg)':'none'};transition:transform .15s ease;
`;
const Menu = styled.div`
  position:absolute;z-index:40;top:calc(100% + 5px);right:0;left:0;overflow:hidden;box-sizing:border-box;padding:7px;
  border:1px solid #e5e5e5;border-radius:7px;background:#fff;box-shadow:0 8px 24px rgba(0,0,0,.12);
`;
const SearchInput = styled.input`
  width:100%;height:34px;box-sizing:border-box;margin-bottom:6px;padding:0 10px;border:1px solid #e5e5e5;
  border-radius:5px;color:#444;font-family:inherit;font-size:var(--font-size-12);outline:none;
  &:focus{border-color:#f5811f;box-shadow:0 0 0 2px rgba(245,129,31,.1);}
`;
const OptionList = styled.div`max-height:220px;overflow-y:auto;border-top:1px solid #f0f0f0;padding-top:4px;`;
const Option = styled.label`
  display:flex;width:100%;min-height:34px;box-sizing:border-box;align-items:center;gap:8px;padding:6px 8px;
  border:0;border-radius:5px;background:#fff;color:#555;font-family:inherit;font-size:var(--font-size-12);text-align:left;cursor:pointer;
  &:hover{background:#fff7f0;color:#d96500;}
  input{width:15px;height:15px;flex:0 0 15px;margin:0;accent-color:#f5811f;pointer-events:none;}
  strong{font-weight:700;} span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
`;
const EmptyOption = styled.div`padding:14px 8px;color:#999;font-size:var(--font-size-12);text-align:center;`;
